<div class="leave-form-modal">
  <p class="leave-form-modal__text" role="alert">
    {{ "healthPlan.dataUnsaved" | translate }}
  </p>

  <div class="leave-form-modal__actions">
    <app-action-button variant="neutral" (clicked)="onClose(false)">
      {{ "shared.noStay" | translate | uppercase }}
    </app-action-button>
    <app-action-button variant="danger" (clicked)="onClose(true)">
      {{ "shared.yesLeave" | translate | uppercase }}
    </app-action-button>
  </div>
</div>
